import { ArrayUtil, HorizontalAlignment, ModelRow } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import {
    DataDisplayEvent, Label, Layout, LayoutProps, SlideoutDecorator, TableRow, TableRowDisplayEvent
} from "@mcleod/components";
import { AutogenLayoutReportScheduleHistory } from "./autogen/AutogenLayoutReportScheduleHistory";

export class ReportScheduleHistory extends AutogenLayoutReportScheduleHistory {
    public static async showInSlideout(reportScheduleId: string) {
        const layoutProps: Partial<LayoutProps> = {
            minWidth: 650,
            width: window.innerWidth * 0.5
        };
        return Layout.getLoadedLayout("common/reports/ReportScheduleHistory", layoutProps)
            .then((layout) => {
                const historyLayout = layout as ReportScheduleHistory;
                SlideoutDecorator.decorateAndSlideIn(historyLayout, {
                    doAfterSlideIn: (_: SlideoutDecorator) => {
                        historyLayout.sourceReportSchedHist.search({ report_schedule_id: reportScheduleId });
                    },
                    fillVerticalSpace: true,
                    titleProps:  {
                        imageColor: "primary.reverse",
                        imageName: ImageName.documentOrderHistory,
                        text: `${historyLayout.title} - ${reportScheduleId}`
                    }
                });
            });
    }

    tableHistoryOnDataDisplay() {
        this.forceRunTimeHeadingCellAlignment();
    }

    tableHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        this.setupLabelReportMessageTooltip(event.getTableRow());
    }

    private forceRunTimeHeadingCellAlignment() {
        const cellRunTime = this.tableHistory.tableHeadingRow.cells.find(cell => cell.caption === "Run Time");
        if (cellRunTime != null) {
            cellRunTime.align = HorizontalAlignment.LEFT;
        }
    }

    /**
     * Sets the report message label's tooltip equal to its text.  This is helpful because the message will likely be
     * longer than can be displayed in the table row, but we don't want the text to wrap.  So let the user see the full
     * text when they hover over the label.
     */
    private setupLabelReportMessageTooltip(tableRow: TableRow) {
        const modelRow = tableRow.data as ModelRow;
        if (modelRow != null) {
            const labelReportMessage =
                ArrayUtil.getFirstElement(tableRow.findComponentsByField("report_message")) as Label;
            if (labelReportMessage != null) {
                labelReportMessage.tooltipDynamicContent = () => {
                    if (!labelReportMessage.isEmpty() &&
                        labelReportMessage.text !== labelReportMessage.nullDisplayValue) {
                        return { text: modelRow.get(labelReportMessage.field, null) };
                    }
                    return null;
                };
            }
        }
    }

    labelRunSecondsOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (!label.isEmpty() && label.text !== label.nullDisplayValue) {
            const runTimeSeconds = Number(label.text);
            if (isNaN(runTimeSeconds)) {
                label.text = null;
            } else {
                const minutes = Math.trunc(runTimeSeconds / 60);
                const seconds = runTimeSeconds % 60;
                label.text = `${minutes}m, ${seconds}s`;
            }
        }
    }
}
